//@ts-check
import useIndustries from './useIndustries';

/** @param {import('@action-types/ecApp').AppDetails['categories']} categories */
const useLabeledIndustries = (categories) => {
  const industries = categories?.filter((category) => category.type === 'industry');
  const industriesQuery = useIndustries({ enabled: industries?.length > 0 });
  const allIndustries = industriesQuery.data?.industries;

  const labeledIndustries = industries?.map((industry) => {
    const matchingIndustry = allIndustries?.find(({ value }) => value === industry.value);
    const label = matchingIndustry?.label || industry.value;
    return { ...industry, label };
  });

  return { labeledIndustries, industriesQuery };
};

export default useLabeledIndustries;
